import banshu from '../../view/Panel/banshu/index.vue'
import weike from '../../view/Panel/weike/index.vue'
import pizhu from '../../view/Panel/pizhu/index.vue'
import kejian from '../../view/Panel/kejian/index.vue'
import banji from '../../view/Panel/banji/index.vue'
import shouce from '../../view/Panel/caozuoshouce/index.vue'
import banshudetail from '../../view/Panel/banshu/details.vue'

export default [{
  path: '/banshu',
  component: banshu,
},
{
  path: '/banshu/details',
  component: banshudetail,
  meta: {
    activeMenu: '/banshu'
  }
},
{
  path: '/weike',
  component: weike
},
{
  path: '/pizhu',
  component: pizhu
},
{
  path: '/kejian',
  component: kejian
},
{
  path: '/banji',
  component: banji
},
{
  path: '/shouce',
  component: shouce
},


]



// WEBPACK FOOTER //
// ./src/router/model/banshu.js